import React from 'react';
import { Box } from '@mui/material';
import CustomerList from '../components/customers/CustomerList';
import { useSelector } from 'react-redux';

function CustomersPage() {
  const { customers = [] } = useSelector((state) => state.customers || {});
  const { query: searchQuery, results } = useSelector(
    (state) => state.search || {}
  );

  const displayedCustomers = searchQuery ? results?.customers || [] : customers;

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <CustomerList customers={displayedCustomers} />
    </Box>
  );
}

export default CustomersPage;
